// Which UI this tab is running. The desktop redesign lives at /V2, served by
// the same build and the same Express catch-all as the classic app at / — so
// it shares the session cookie, every /api/* route, localStorage and the
// IndexedDB mail cache. Only the shell differs (see src/v2/README.md).
//
// Decided once from the address at boot. Nothing in the app changes the path
// afterwards (mailbox switching only rewrites the query string — see
// lib/impersonate.js mailboxHref), so a tab never flips between the two.

export const V2_BASE = '/V2';

export function isV2Path(pathname) {
  return /^\/v2(\/|$)/i.test(pathname || '');
}

export function isV2() {
  return typeof window !== 'undefined' && isV2Path(window.location.pathname);
}

// The same mailbox / view in the other UI — keeps ?as=…&shared=… so an admin
// looking at a colleague's mailbox stays on it when switching.
export function classicHref() {
  return '/' + window.location.search + window.location.hash;
}

export function v2Href() {
  return V2_BASE + window.location.search + window.location.hash;
}
